import { useCallback } from "react"
import { useIntervalEffect } from "./useIntervalEffect"
import { useStateWithPreservation } from "./useStateWithPreservation"

export function useStateWithIntervalUpdate(updater, updateEvery = 1000) {
  const [
    state,
    setState
  ] = useStateWithPreservation(() => updater())

  useIntervalEffect(
    useCallback(() => {
      setState(updater())
    }, [updater, setState]),
    updateEvery,
    false,
  )

  return state
}
